import { createApp } from 'vue';
import { getBrand } from '@/services/brand/getBrand';
import { GetBrandResponse } from '@/types/response';
import { Brand } from '@/types/brand';
import urls from '@/utils/urls';

const app = createApp({
  data() {
    return {
      brand: {} as Brand,
      layers: [] as Array<{ layer: string, title: string }>,
    };
  },
  computed: {
    isTopLayer(): boolean {
      return this.layers.length === 0;
    },
    isCurrentLayer(): (title: string) => boolean {
      return (title: string): boolean => this.title === title;
    },
    title(): string {
      return this.isTopLayer ? '' : this.layers[this.layers.length - 1].title;
    },
    linkToSneakerBrandPage(): string {
      return urls.sneakerBrand(this.brand.id);
    },
    linkToSneakerModelPage(): (id: string) => string {
      return (id: string): string => urls.sneakerModels(id);
    },
  },
  watch: {
    layers: {
      handler() {
        this.$refs.hgMenuWrapper.classList.remove('layer2', 'layer3');
        if (!this.isTopLayer) {
          this.$refs.hgMenuWrapper.classList.add(this.layers[this.layers.length - 1].layer);
        }
      },
      deep: true,
    },
  },
  methods: {
    open(): void {
      const className = 'active';
      this.$refs.hgMenuBg.classList.add(className);
      this.$refs.hgMenu.classList.add(className);
    },
    close(): void {
      const className = 'active';
      this.$refs.hgMenuBg.classList.remove(className);
      this.$refs.hgMenu.classList.remove(className);
      this.resetLayer();
    },
    pushLayer(layer: string, title: string): void {
      this.layers.push({ layer, title });
    },
    popLayer(): void {
      this.layers.pop();
    },
    resetLayer() {
      this.layers = [] as Array<{ layer: string, title: string }>;
    },
    selectSneakerBrand(e: Event): void {
      const brandId = (e.currentTarget as HTMLAnchorElement).getAttribute('data-brand-id');
      if (brandId !== null) {
        getBrand(brandId).then((res: GetBrandResponse) => {
          this.brand = res.brand;
          this.pushLayer('layer3', res.brand.name);
        });
      }
    },
    confirmLogout(event: Event): void {
      const v = window.confirm('Are you sure you want to log out?');
      if (!v) event.preventDefault();
    },
  },
});
app.mount('#header');
